import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../i18n/getLocale';

class StaffPapersAdd extends Component {
  
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      month: null,
      staff_id: null,
      date_start: '',
      date_finish: '',
      staffs: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tripulantes/ativos/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staffs: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      month: this.state.month,
      staff_id: this.state.staff_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/papeleta/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Papeletas.AdicionarPapeleta.titulo}</h3>
      <Link to="/papeletas/abertas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Papeletas.AdicionarPapeleta.formulario.MesAno}:</label>
              <InputMask value={this.state.month}  maskChar={null} name="month" mask="99/9999" className="form-control" onChange={this.handleChange.bind(this, 'month')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Papeletas.AdicionarPapeleta.formulario.Tripulante}:</label>
              <Select
                className="form-field-name"
                name="staff_id"
                value={this.state.staff_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'staff_id')}
                options={this.state.staffs}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default StaffPapersAdd;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/StaffPapersAdd.js